import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { useSelector } from "react-redux";
import { Color, globalFontStyle } from "../../../assets";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const data = [
  "Register to join contest",
  "Register to join contest",
  "Register to join contest",
];

const HowToContest = ({
  isBottomSheet,
  isShowCTA,
  onCallbackHowToContest,
  coinsTobeAdded,
}) => {
  const logedIn = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  const onBtnCLick = () => {
    //if (!logedIn) {
    onCallbackHowToContest();
    //}
  };
  const contestConfig = useSelector(
    (state) => state.utilReducer.globalConfigData?.contestConfig
  );
  // const contestJoiningFee = joiningFee;
  return (
    <View
      style={[
        {
          //paddingHorizontal: 10,
          paddingVertical: 20,
          paddingHorizontal: 15,
          flex: 1,
          justifyContent: "flex-start",
        },
        isBottomSheet ? { width: Width.width } : styles.aboutContestContainer,
      ]}
    >
      <FormTextLabel
        labelStyles={[
          {
            ...globalFontStyle.appFontTitle,
            color: Color.black,
            marginBottom: isBottomSheet ? 30 : 20,
          },
          !isBottomSheet ? { ...globalFontStyle.appFontSubTextBold } : null,
        ]}
        label={"How it works"} />
      {(contestConfig?.howItWorks?.info || []).map((qaItem, i) => {
        let a = qaItem;
        if (qaItem.includes("virtual_coins")) {
          a = qaItem.replace("virtual_coins", coinsTobeAdded || 10000);
        }
        return (
          <View key={i}>
            <Text
              style={{
                ...globalFontStyle.appFontSubText,
                color: Color.black,
                paddingVertical: isBottomSheet ? 15 : 10,
              }}
            >
              {i + 1 + "."} &nbsp;
              {a}
            </Text>
          </View>
        );
      })}
      <View
        style={[
          styles.disclaimerContainer,
          !isBottomSheet ? { marginBottom: 5 } : null,
        ]}
      >
        <Text style={styles.disclaimerTextStyle}>
          {contestConfig?.howItWorks?.disclaimer}
        </Text>
      </View>
      {isShowCTA && (
        <CustomButton
          btnText={logedIn ? "Confirm Participation" : "Register to trade"}
          btnType={"btnBlack"}
          onBtnClick={onBtnCLick}
          customStyle={{ flex: 1 }}
          translate={true}
          // isSubText={
          //   logedIn
          //     ? `(${contestJoiningFee} will be deducted from your wallet)`
          //     : null
          // }
        />
      )}
    </View>
  );
};

export default HowToContest;

const styles = StyleSheet.create({
  disclaimerContainer: {
    borderRadius: 8,
    padding: 13,
    backgroundColor: "#F5F7F9",
    marginBottom: 30,
    marginTop: 15,
  },
  disclaimerTextStyle: {
    ...globalFontStyle.appFontSmallText,
    color: "#5B6779",
  },
  aboutContestContainer: {
    // elevation: 5,
    borderWidth: 0.2,
    borderRadius: 8,
    borderColor: "rgba(0, 0, 0, 0.25)",
    marginTop: 15,
  },
});
